module.exports = __webpack_public_path__ + "img/f77b633.png";